import axios from 'axios';
import Forms from '../common/forms';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

export default class Contact {
    constructor() {
        this.section = document.querySelector('.block-contact')
        this.anchor = document.querySelector('body')
        this.form = document.querySelector('#contactForm');
        this.formFields = this.form.querySelectorAll('input, select, textarea')
		this.successMessage = this.section.querySelector('.block-contact .success-form')
		this.errorMessage = this.section.querySelector('.block-contact .error-form')
        this.errorSubmitMessage = this.section.querySelector('.block-contact .error-submit-form')
        this.btnSubmit = this.form.querySelector('button');

        new Forms();
        Forms.initRecaptchaOnFocus(this.form);

        this.ready();
    }

    ready() {
        
        new Bouncer(`#contactForm`, {
            ...Forms.config(),
            messages: Forms.messages(),
        });


        this.form.addEventListener('bouncerShowError', () => {
            this.errorMessage.classList.remove('hidden')
        }, false);
        
        this.form.addEventListener('bouncerFormInvalid', () => {
            Forms.activeErros(this.form);
        }, false);

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendForm(event.target);
                    // console.log('Formulário validado e pronto para ser enviado via AJAX.');
                }
            },
            false
        );
    }

    sendForm(form) {

        // garante que o input existe
        let tokenInput = form.querySelector("input[name='g-recaptcha-response']");
        if (!tokenInput) {
            tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = 'g-recaptcha-response';
            form.appendChild(tokenInput);
        }

        window.reloadCaptcha('contact', 'g-recaptcha-response', () => {

            // ---- LIMPA ERROS VISUAIS ----
            
            // remove error-field de todos os inputs
            form.querySelectorAll('.error-field').forEach(el => {
                el.classList.remove('error-field');
            });

            // remove error-field dos prefixos
            form.querySelectorAll('.addPrefixInput.error-field').forEach(el => {
                el.classList.remove('error-field');
            });

            // esconde todos os erros
            form.querySelectorAll('.erro-campo').forEach(el => {
                el.classList.add('hidden');
            });

            this.errorSubmitMessage.classList.add('hidden');
            this.successMessage.classList.add('hidden');
            this.errorMessage.classList.add('hidden');

			this.btnSubmit.disabled = true
            this.btnSubmit.classList.add('loading')
			const dataForm = new FormData(form)

			if (this.form.querySelector('#accepted').checked) {
                dataForm.set('accepted', 1);
			} else {
                dataForm.set('accepted', 0);
			}

			axios.post(base_url + 'sendContact', dataForm, {
                headers: { 'Accept': 'application/json' }
            })
                .then((response) => {
                    form.reset();

                    this.errorMessage.classList.add('hidden');
                    this.errorSubmitMessage.classList.add('hidden');
                    this.successMessage.classList.remove('hidden');

                    this.btnSubmit.disabled = false;
                    this.btnSubmit.classList.remove('loading');

                    this.successMessage.scrollIntoView({ behavior: 'smooth' });

                    setTimeout(() => {
                        this.successMessage.classList.add('hidden');
                    }, 10000);
                })

                .catch((error) => {
                    console.group('Erro Axios');
                    
                    console.log('Mensagem:', error.message);

                    if (error.response) {
                        console.log('Status:', error.response.status);
                        console.log('Headers:', error.response.headers);
                        console.log('Data:', error.response.data); // ESSA É A MAIS IMPORTANTE
                    } else if (error.request) {
                        console.log('Nenhuma resposta recebida. Request:', error.request);
                    }

                    console.groupEnd();
                    console.error('Erro ao enviar o formulário');
                    this.successMessage.classList.add('hidden');
                    this.errorMessage.classList.add('hidden');
                    this.errorSubmitMessage.classList.remove('hidden');
                    // this.anchor.scrollIntoView({ behavior: 'smooth' });
                    this.btnSubmit.disabled = false;
                    this.btnSubmit.classList.remove('loading')
                });
		})
    }

}

if(document.querySelector('.block-contact')) {
    new Contact()
}
